import NotFound from 'components/atoms/notFound';
import AdminAgencyViewPage from 'pages/admin/agency';
import AdminAgencies from 'pages/admin/agencies';
import AdminAgencyAdd from 'pages/admin/agencyAdd';
import AdminAgencyEdit from 'pages/admin/agencyEdit';
import AdminClinicViewPage from 'pages/admin/clinic';
import AdminClinicAddPage from 'pages/admin/clinicAdd';
import AdminClinicEditPage from 'pages/admin/clinicEdit';
import AdminClinics from 'pages/admin/clinics';
import AdminAgencyDoctorInfo from 'pages/admin/hhaDoctor';
import AdminAgencyDoctorAdd from 'pages/admin/hhaDoctorAdd';
import AdminAgencyDoctorEdit from 'pages/admin/hhaDoctorEdit';
import AdminAgencyDoctorList from 'pages/admin/hhaDoctors';
import AdminPatientDetailsPage from 'pages/admin/patient/index';
import AdminPatientAdd from 'pages/admin/patientAdd';
import AdminPatients from 'pages/admin/patients';
import AdminTurkUserInfoPage from 'pages/admin/turkUser';
import AdminTurkUsersPage from 'pages/admin/turkUsers';
import AdminUser from 'pages/admin/user';
import AdminUserAdd from 'pages/admin/userAdd';
import AdminUserEdit from 'pages/admin/userEdit';
import AdminUsers from 'pages/admin/users';
import AppEmptyLayout from 'pages/app/empty-layout';
import MainAppLayout from 'pages/app/layout';
import BillingClaimsAthenaPage from 'pages/billingTools/claims/athena';
import EpicClaimsPage from 'pages/billingTools/claims/epic';
import CallDashboardPage from 'pages/call-dashboard';
import CCMConsentForm from 'pages/ccm/consentForm';
import ApcmConsentFormPage from 'pages/apcm/consent-form';
import CcmAgentDashboardPage from 'pages/ccm/dashboards/ccmAgentDashboard';
import CCMPatientDetails from 'pages/ccm/patientDetails';
import CCMPatientsActivities from 'pages/ccm/patientsActivities';
import CCMBillingReport from 'pages/ccm/practice/billingReport';
import CCMBillingReportV2 from 'pages/ccm/practice/billingReportV2';
import CCMInteractiveTimeReport from 'pages/ccm/practice/ccmInteractiveReport';
import CcmOnboardingStatus from 'pages/ccm/practice/ccmOnboardingStatus';
import CCMStatusReport from 'pages/ccm/practice/statusReport';
import PatientProfile from 'pages/patient-profile/unified';
import PatientSessionLayout from 'pages/patient-session-layout';
import Profile from 'pages/profile';
import ClinicalMetrics from 'pages/rpm/practice/clinicalMetrics';
import ComplianceReport from 'pages/rpm/practice/complianceReport';
import EligibilityItemsPage from 'pages/tools/eligibility/items';
import EligibilityPage from 'pages/tools/eligibility';
import EmailUnsubscribePage from 'pages/public/emailSubscription';
import EmailUnsubscribedPage from 'pages/public/emailUnsubscribed';
import ResetPasswordLinkPage from 'pages/public/resetPasswordLink';
import InteractiveTimeDashboardPage from 'pages/rpm/interactiveTimeDashboard';
import InteractiveTimeReportV2 from 'pages/rpm/practice/interactiveReportV2';
import InteractionStatus from 'pages/rpm/practice/interactionStatus';
import ApcmEligibilityReport from 'pages/apcm/practice/eligibilityReport';
import MedicareBilling from 'pages/rpm/practice/medicareBilling';
import OnboardingStatus from 'pages/rpm/practice/onboardingStatus';
import PatientDetails from 'pages/rpm/patients/patientDetails';
import NormalReadingsReport from 'pages/rpm/practice/normal-readings-report';
import PatientEngagementStatusReport from 'pages/rpm/practice/patientEngagementStatusReport';
import PatientsStatusReport from 'pages/rpm/practice/patientsStatusReport';
import PerformanceReview from 'pages/rpm/practice/performanceReview';
import SmsDashboard from 'pages/smsDashboard';
import SmsDashboardMetricsPage from 'pages/sms-dashboard-metrics';
import SSO from 'pages/sso';
import SSOLogin from 'pages/sso/login';
import StatisticsReport from 'pages/rpm/practice/statisticsReport';
import ActivityReport from 'pages/rpm/practice/activity-report';
import AdherenceLast30DaysReport from 'pages/rpm/practice/adherenceReport/last30DaysAdherence';
import AdherenceReport from 'pages/rpm/practice/adherenceReport';
import TurkConfigurationPage from 'pages/admin/turkConfiguration';
import TurkDashboardPage from 'pages/turkDashboard';
import TurkUserAddPage from 'pages/admin/turkUserAdd';
import TurkUserEditPage from 'pages/admin/turkUserEdit';
import NewPatientsReport from 'pages/rpm/practice/newPatients';
import CallHistoryManagementPage from 'pages/tools/callHistoryManagement';
import UntrackedInboundCallsPage from 'pages/tools/untrackedInboundCalls';
import { createBrowserRouter } from 'react-router-dom';
// import { CareManagerPatientsTransferPage } from 'pages/admin/patientsTransfer';
import CallAgentsDashboardActivityPage from 'pages/call-agents-dashboard/activity';
import CallAgentsDashboardMetricsPage from 'pages/call-agents-dashboard/metrics';
import CallAgentsDashboardQueuesPage from 'pages/call-agents-dashboard/queues';
import CallAgentProfileDashboardPage from 'pages/call-agents-dashboard/agent-profile';
import SmsCampaignDashboard from 'pages/sms-campaign/dashboard';
import SmsCampaignPage from 'pages/sms-campaign/campaign';
import SmsCampaignResponsesPage from 'pages/sms-campaign/responses';
import SmsCampaignSummaryPage from 'pages/sms-campaign/summary';
import CampaignForm from 'components/organisms/sms-campaigns/outcome-form';
import CCMConsolePage from 'pages/ccm/console';
import SmsAutoReplySettingsPage from 'pages/smsAutoReplySettings';
import OverviewDashboardPage from 'pages/rpm/overviewDashboard';
import { ProviderDashboard } from 'pages/providerDashboard';
import AdherenceSettingsCohortsInactiveDaysPage from 'pages/adherence-settings/cohorts-inactive-days';
import AdherenceSettingsQueueLimitsPage from 'pages/adherence-settings/queue-limits';
// import ActionTimeManagementTool from 'pages/tools/action-time-management';
import LinkCallReadingsTool from 'pages/tools/link-call-readings';
import AuthProvider from 'infrastructure/providers/auth-provider';
import { CareManagerPatientsTransferPage } from 'pages/admin/patientsTransfer';

import { PublicRoutes, Routes } from './routes';
import { wrapAccessRoute, wrapProtect } from './generate-routes';

import type { RouteObject } from 'react-router-dom';

const agentGuid = ':agentGuid';
const patientGuid = ':patientGuid';
const userGuid = ':userGuid';
const agencyGuid = ':agencyGuid';
const clinicGuid = ':clinicGuid';
const campaignGuid = ':campaignGuid';

const routes: RouteObject[] = [
  {
    element: <AuthProvider />,
    children: [
      {
        element: <AppEmptyLayout />,
        children: [
          {
            path: PublicRoutes.emailSubscription,
            element: <EmailUnsubscribePage />,
          },
          {
            path: PublicRoutes.emailUnsubscribed,
            element: <EmailUnsubscribedPage />,
          },
          { path: PublicRoutes.ssoLogin, element: <SSOLogin /> },
          {
            path: PublicRoutes.resetPassword,
            element: <ResetPasswordLinkPage />,
          },
          {
            path: PublicRoutes.smsCampaignForm,
            element: <CampaignForm />,
          },
        ],
      },
      {
        path: '/',
        element: wrapProtect(MainAppLayout),
        children: [
          wrapAccessRoute({
            path: '*',
            element: NotFound,
          }),
          wrapAccessRoute({
            path: Routes.notFound,
            element: NotFound,
          }),
          wrapAccessRoute({
            path: Routes.activityReport,
            element: ActivityReport,
          }),
          wrapAccessRoute({
            path: Routes.adherenceReport,
            element: AdherenceReport,
          }),
          wrapAccessRoute({
            path: Routes.adherenceReportLast30Days,
            element: AdherenceLast30DaysReport,
          }),
          wrapAccessRoute({
            path: Routes.adminAgencyList,
            element: AdminAgencies,
          }),
          wrapAccessRoute({
            path: Routes.adminAgency(agencyGuid),
            element: AdminAgencyViewPage,
          }),
          wrapAccessRoute({
            path: Routes.adminAgencyAdd,
            element: AdminAgencyAdd,
          }),
          wrapAccessRoute({
            path: Routes.adminAgencyDoctor(agentGuid),
            element: AdminAgencyDoctorInfo,
          }),
          wrapAccessRoute({
            path: Routes.adminAgencyDoctorAdd,
            element: AdminAgencyDoctorAdd,
          }),
          wrapAccessRoute({
            path: Routes.adminAgencyDoctorEdit(agentGuid),
            element: AdminAgencyDoctorEdit,
          }),
          wrapAccessRoute({
            path: Routes.adminAgencyDoctorList,
            element: AdminAgencyDoctorList,
          }),
          wrapAccessRoute({
            path: Routes.adminAgencyEdit(agencyGuid),
            element: AdminAgencyEdit,
          }),
          wrapAccessRoute({
            path: Routes.adminClinic(clinicGuid),
            element: AdminClinicViewPage,
          }),
          wrapAccessRoute({
            path: Routes.adminClinicAdd,
            element: AdminClinicAddPage,
          }),
          wrapAccessRoute({
            path: Routes.adminClinicEdit(clinicGuid),
            element: AdminClinicEditPage,
          }),
          wrapAccessRoute({
            path: Routes.adminClinics,
            element: AdminClinics,
          }),
          wrapAccessRoute({
            path: Routes.adminPatientAdd,
            element: AdminPatientAdd,
          }),
          wrapAccessRoute({
            path: Routes.adminPatients,
            element: AdminPatients,
          }),
          wrapAccessRoute({
            path: Routes.adminTurkConfigurations,
            element: TurkConfigurationPage,
          }),
          wrapAccessRoute({
            path: Routes.adminTurkUser(agentGuid),
            element: AdminTurkUserInfoPage,
          }),
          wrapAccessRoute({
            path: Routes.adminTurkUserList,
            element: AdminTurkUsersPage,
          }),
          wrapAccessRoute({
            path: Routes.adminTurkUsersAdd,
            element: TurkUserAddPage,
          }),
          wrapAccessRoute({
            path: Routes.adminTurkUsersEdit(agentGuid),
            element: TurkUserEditPage,
          }),
          wrapAccessRoute({
            path: Routes.adminUser(userGuid),
            element: AdminUser,
          }),
          wrapAccessRoute({
            path: Routes.adminUserAdd,
            element: AdminUserAdd,
          }),
          wrapAccessRoute({
            path: Routes.adminUserEdit(userGuid),
            element: AdminUserEdit,
          }),
          wrapAccessRoute({
            path: Routes.adminUsers,
            element: AdminUsers,
          }),
          wrapAccessRoute({
            path: Routes.billingClaimsAthena,
            element: BillingClaimsAthenaPage,
          }),
          wrapAccessRoute({
            path: Routes.billingClaimsEpic,
            element: EpicClaimsPage,
          }),
          wrapAccessRoute({
            path: Routes.ccm,
            element: CCMConsolePage,
          }),
          wrapAccessRoute({
            path: Routes.ccmConsole,
            element: CCMPatientsActivities,
          }),
          wrapAccessRoute({
            path: Routes.ccmAgentDashboard,
            element: CcmAgentDashboardPage,
          }),
          wrapAccessRoute({
            path: Routes.ccmBillingReport,
            element: CCMBillingReport,
          }),
          wrapAccessRoute({
            path: Routes.ccmBillingReportV2,
            element: CCMBillingReportV2,
          }),
          wrapAccessRoute({
            path: Routes.ccmConsent(patientGuid),
            element: CCMConsentForm,
          }),
          wrapAccessRoute({
            path: Routes.apcmConsent(patientGuid),
            element: ApcmConsentFormPage,
          }),
          wrapAccessRoute({
            path: Routes.apcmEligibilityReport,
            element: ApcmEligibilityReport,
          }),
          wrapAccessRoute({
            path: Routes.ccmInteractiveTimeReport,
            element: CCMInteractiveTimeReport,
          }),
          wrapAccessRoute({
            path: Routes.ccmOnboardingStatus,
            element: CcmOnboardingStatus,
          }),
          wrapAccessRoute({
            path: Routes.ccmPatient(patientGuid),
            element: CCMPatientDetails,
          }),
          wrapAccessRoute({
            path: Routes.ccmStatusReport,
            element: CCMStatusReport,
          }),
          wrapAccessRoute({
            path: Routes.smsCampaign,
            element: SmsCampaignDashboard,
          }),
          wrapAccessRoute({
            path: Routes.smsCampaignGuid(campaignGuid),
            element: SmsCampaignPage,
          }),
          wrapAccessRoute({
            path: Routes.smsCampaignResponses(campaignGuid),
            element: SmsCampaignResponsesPage,
          }),
          wrapAccessRoute({
            path: Routes.smsCampaignSummary(campaignGuid),
            element: SmsCampaignSummaryPage,
          }),
          wrapAccessRoute({
            path: Routes.callAgentsDashboardActivity,
            element: CallAgentsDashboardActivityPage,
          }),
          wrapAccessRoute({
            path: Routes.callAgentProfile(':agentGuid'),
            element: CallAgentProfileDashboardPage,
          }),
          wrapAccessRoute({
            path: Routes.callAgentsDashboardMetrics,
            element: CallAgentsDashboardMetricsPage,
          }),
          wrapAccessRoute({
            path: Routes.callAgentsDashboardQueues,
            element: CallAgentsDashboardQueuesPage,
          }),
          wrapAccessRoute({
            path: Routes.patientTransfer,
            element: CareManagerPatientsTransferPage,
          }),
          wrapAccessRoute({
            path: Routes.clinicalMetrics,
            element: ClinicalMetrics,
          }),
          wrapAccessRoute({
            path: Routes.complianceReport,
            element: ComplianceReport,
          }),
          wrapAccessRoute({
            path: Routes.overviewDashboard,
            element: OverviewDashboardPage,
            index: true,
          }),
          wrapAccessRoute({
            path: Routes.eligibilityTool,
            element: EligibilityPage,
          }),
          wrapAccessRoute({
            path: Routes.eligibilityToolItems(':processGuid'),
            element: EligibilityItemsPage,
          }),
          wrapAccessRoute({
            path: Routes.linkCallReadingTool,
            element: LinkCallReadingsTool,
          }),
          wrapAccessRoute({
            path: Routes.interactionStatus,
            element: InteractionStatus,
          }),
          wrapAccessRoute({
            path: Routes.interactiveTime,
            element: InteractiveTimeReportV2,
          }),
          wrapAccessRoute({
            path: Routes.interactiveTimeDashboard,
            element: InteractiveTimeDashboardPage,
          }),
          wrapAccessRoute({
            path: Routes.medicareBilling,
            element: MedicareBilling,
          }),
          wrapAccessRoute({
            path: Routes.onboardingStatus,
            element: OnboardingStatus,
          }),
          wrapAccessRoute({
            path: Routes.patientDetails,
            element: PatientDetails,
          }),
          {
            element: <PatientSessionLayout />,
            children: [
              wrapAccessRoute({
                path: Routes.patientProfileGuid(patientGuid),
                element: PatientProfile,
              }),
              wrapAccessRoute({
                path: Routes.patientGuid(patientGuid),
                element: PatientProfile,
              }),
              wrapAccessRoute({
                path: Routes.adminPatient(patientGuid),
                element: AdminPatientDetailsPage,
              }),
            ],
          },
          wrapAccessRoute({
            path: Routes.patientsStatusReport,
            element: PatientsStatusReport,
          }),
          wrapAccessRoute({
            path: Routes.performanceReview,
            element: PerformanceReview,
          }),
          wrapAccessRoute({
            path: Routes.profile,
            element: Profile,
          }),
          wrapAccessRoute({
            path: Routes.smsDashboard,
            element: SmsDashboard,
          }),
          wrapAccessRoute({
            path: Routes.providerDashboard,
            element: ProviderDashboard,
          }),
          wrapAccessRoute({
            path: Routes.smsDashboardMetrics,
            element: SmsDashboardMetricsPage,
          }),
          wrapAccessRoute({
            path: Routes.adherenceSettingsCohortsInactiveDays,
            element: AdherenceSettingsCohortsInactiveDaysPage,
          }),
          wrapAccessRoute({
            path: Routes.adherenceSettingsQueueLimits,
            element: AdherenceSettingsQueueLimitsPage,
          }),
          wrapAccessRoute({
            path: Routes.smsAutoReplySettings,
            element: SmsAutoReplySettingsPage,
          }),
          wrapAccessRoute({
            path: Routes.callDashboard,
            element: CallDashboardPage,
          }),
          wrapAccessRoute({
            path: Routes.sso,
            element: SSO,
          }),
          wrapAccessRoute({
            path: Routes.statisticsReport,
            element: StatisticsReport,
          }),
          wrapAccessRoute({
            path: Routes.turkDashboard,
            element: TurkDashboardPage,
          }),
          wrapAccessRoute({
            path: Routes.untrackedInboundCalls,
            element: UntrackedInboundCallsPage,
          }),
          wrapAccessRoute({
            path: Routes.callHistoryManagement,
            element: CallHistoryManagementPage,
          }),
          wrapAccessRoute({
            path: Routes.newPatientsReport,
            element: NewPatientsReport,
          }),
          wrapAccessRoute({
            path: Routes.normalReadingsReport,
            element: NormalReadingsReport,
          }),
          wrapAccessRoute({
            path: Routes.patientEngagementStatusReport,
            element: PatientEngagementStatusReport,
          }),
          // wrapAccessRoute({
          //   path: Routes.actionTimeManagementTool,
          //   element: ActionTimeManagementTool,
          // }),
        ],
      },
      {
        path: PublicRoutes.ssoLogin,
        element: <SSOLogin />,
      },
      {
        path: PublicRoutes.resetPassword,
        element: <ResetPasswordLinkPage />,
      },
    ],
  },
];

export const router = createBrowserRouter(routes, {
  future: {
    v7_relativeSplatPath: true,
    v7_partialHydration: true,
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_skipActionErrorRevalidation: true,
  },
});
